import { createSlice } from "@reduxjs/toolkit";
import {
  addBusinessAction,
  deleteBusinessAction,
  getBusinessAction,
  getUserKeysAction,
} from "../../actions";
import {
  addAllBusinessAction,
  getGbpBusinessPaginatedAction,
} from "../../actions/UserActions/LocalBusinessAction";

interface IUserKeys {
  places_key: string;
  google_client_id: string;
}

export interface IBusiness {
  _id: string;
  business_name: string;
  data_cid: string;
  address: string;
  formatted_address?: string;
  location: {
    type: string;
    coordinates: [number, number];
  };
  center: {
    type: string;
    coordinates: [number, number];
  };
  rating: number;
  reviews: number;
  keywords: string[];
  public_share_hash: string;
  added_by: string;
  url: string;
  public: boolean;
  place_id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  ctr_enabled: boolean;
  ctr_expiry: string | null;
  map_checkin_enabled: boolean;
  map_checkin_expiry: string | null;
  geo_booster_enabled: boolean;
  geo_booster_expiry: string | null;
  website?: string;
}

interface ILocalBusinessState {
  loading: boolean;
  userKeys: IUserKeys | null;
  business: IBusiness[];

  getGbpData: any[];
  getGbpDataPagination: any;
  getGbpEmails: string[];
}

const initialState: ILocalBusinessState = {
  loading: false,
  userKeys: null,
  business: [],
  getGbpData: [],
  getGbpDataPagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
  getGbpEmails: [],
};

const localBusinessSlice = createSlice({
  name: "localBusiness",
  initialState,
  reducers: {
    setclearBusiness: (state) => {
      state.getGbpData = [];
    },
  },
  extraReducers: (builder) => {
    //get user keys
    builder.addCase(getUserKeysAction.pending, (state) => {
      state.loading = true;
      state.userKeys = null;
    });
    builder.addCase(getUserKeysAction.fulfilled, (state, action) => {
      state.loading = false;
      state.userKeys = action.payload.data;
    });
    builder.addCase(getUserKeysAction.rejected, (state) => {
      state.loading = false;
      state.userKeys = null;
    });

    //get business
    builder.addCase(getBusinessAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBusinessAction.fulfilled, (state, action) => {
      state.loading = false;
      state.business = action.payload.data;
    });
    builder.addCase(getBusinessAction.rejected, (state) => {
      state.loading = false;
    });

    //add business
    builder.addCase(addBusinessAction.fulfilled, (state, action) => {
      state.business.push(action.payload.data);
    });

    //add all business
    builder.addCase(addAllBusinessAction.fulfilled, (state, action) => {
      state.business = [...state.business, action.payload.data];
    });

    //delete business
    builder.addCase(deleteBusinessAction.fulfilled, (state, action) => {
      const deletedId = action.meta.arg;
      state.business = state.business.filter(
        (business) => business._id !== deletedId,
      );
    });

    //get gbp business
    //         builder.addCase(getGbpBusinessAction.fulfilled, (state, action) => {
    //             state.getGbpData = action.payload.data;
    //         });
    builder.addCase(getGbpBusinessPaginatedAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getGbpBusinessPaginatedAction.fulfilled,
      (state, action) => {
        state.loading = false;
        state.getGbpData = action.payload?.data;
        state.getGbpDataPagination = action.payload?.pagination;
        state.getGbpEmails = action.payload?.emails || [];
      },
    );
    builder.addCase(getGbpBusinessPaginatedAction.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { setclearBusiness } = localBusinessSlice.actions;
export default localBusinessSlice.reducer;
